export default __webpack_public_path__ + "static/media/person.77fb1ab0.png";